// global.api_url = 'http://184.168.125.152/plesk-site-preview/99solutions.co.in/https/184.168.125.152/Express/DEV2/zship'
//global.api_url = 'https://zship.in/TEST_ZSHIP_BETA/zship'
export {};
global.api_url = 'https://betaapi.anyshipp.com'
global.ndr_upload_format = 'https://betaapi.anyshipp.com//upload/format/ndr_upload.xlsx'
global.bulk_upload_format = 'https://betaapi.anyshipp.com/upload/format/uploadfile_bulk.csv'
global.upload_resp_url = 'https://betaorders.anyshipp.com/storage/app'
global.trackingid_upload_format = 'https://betaapi.anyshipp.com/upload/format/trackingid_upload.csv'
global.pincode_url = 'https://betapostalcodes.anyshipp.com'
global.billing_url = 'https://betabilling.anyshipp.com'
global.billing_storage = 'http://43.205.171.148:8010/storage/public'
global.privacy_policy_url = 'https://api.anyshipp.com/assets/Privacy_Policy_Anyshipp.pdf';
global.privacy_policy_viewer = `https://docs.google.com/viewer?url=${global.privacy_policy_url}&embedded=true`;
global.terms_of_service_url = 'https://api.anyshipp.com/assets/Terms_of_Service_Anyshipp.pdf';
global.terms_of_service_viewer = `https://docs.google.com/viewer?url=${global.terms_of_service_url}&embedded=true`;
global.razorpay_key = 'rzp_test_Sx2KFduwLYjESU';